import { combineReducers } from 'redux';

import audit from './audit';
import checklists from './checklists';
import stocks from './stocks';
import tscan from './tscan';

/**
 * @typedef {{
 *  audit: import('./audit').AuditState,
 *  tscan: import('./tscan').TScanState,
 *  stocks:import('./stocks').InterventionImportStockReducer
 * }} ImportsState
 */

export default combineReducers({
  audit,
  tscan,
  stocks,
  checklists
});
